import { Option, isSome } from 'fp-ts/lib/Option'

export const somes = <T>(as: readonly Option<T>[]) => as.filter(isSome).map(a => a.value)

export const noop = () => {}

export const isNotNullOrUndefined = <T>(input: null | undefined | T): input is T => input !== null && input !== undefined
